import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    translation: {
      'common.delete': 'Delete',
      'common.apply': 'Apply',
      'common.ok': 'OK',
      'common.close': 'Close',
      'common.copy': 'Copy',
      'common.copyToClipboard': 'Was copied to clipboard',
      'common.reset': 'Reset',
      'common.approve': 'Approve',
      'common.loading': 'Loading ...',
      'common.loadMore': 'Load more',
      'common.send': 'Send',
      'common.slogan': 'Easy electronic check management',
      'common.logout': 'Log out',
      'common.termsAgreement': 'I agree to ',
      'common.termsAndConditions': 'Terms and Conditions',
      'common.note': 'Note',
      'common.archive': 'Archive',
      'common.all': 'All',
      'common.activate': 'Activate',
      'common.selectNoOptions': 'No options available',

      'common.emptyState': 'No items found',
      'common.emptyState.clearFilters': 'Clear filters',
      'common.emptyState.description':
        'There are no items to display at the moment. \nTry adjusting your filters or check back later.',

      // user menu
      'menu.backToHome': 'Back to home',
      'menu.myPayments': 'My payments',
      'menu.myPayees': 'My payees',
      'menu.allPayees': 'Payees',
      'menu.allPayments': 'Payments',
      'menu.banks': 'Banks',
      'menu.settings': 'Settings',
      'menu.audit': 'Audit History',
      'menu.logOut': 'Log out',
      'menu.profile': 'Profile',
      'menu.tour': 'App Tour',

      // empty
      'common.empty.header': 'This page is under development',
      'common.empty.subHeader': 'This is empty sub header',

      // common navigation
      'common.navigation.backToLogin': 'Back to login',

      // navigation support
      'navigation.support.helpAndLegal': 'Help & Legal',
      'navigation.support.helpAndSupport': 'Help & Support',
      'navigation.support.disclaimer': 'Disclaimer',
      'navigation.support.privacyPolicy': 'Privacy Policy',
      'navigation.support.termsAndConditions': 'Terms & Conditions',

      // forms
      'common.form.email.label': 'email',
      'common.form.email.placeholder': 'Enter email address',
      'common.form.email.error.invalid': 'Invalid Email Address',
      'common.form.email.notFoundText': 'No email found',
      'common.form.emptyFieldError': 'This field is required',

      'common.form.password.label': 'Password',
      'common.form.password.placeholder': 'Enter Password',
      'common.form.password.hint':
        '{{minLength}} characters minimum, case sensitive.',
      'common.form.save': 'Save',
      'common.form.invite': 'Invite',
      'common.form.request': 'Request',
      'common.form.saveAsDraft': 'Draft',
      'common.form.cancel': 'Cancel',
      'common.form.deleteConfirm': 'Are you sure you want to delete this item?',
      'common.form.confirm': 'Confirm',
      'common.form.fieldRequired': 'This field is required',
      'common.form.enterValueFor': 'Enter value for ',
      'common.form.enterValueTo': 'Enter value to ',
      'common.form.typeToSearchValueFor': 'Search value for ',

      'common.typeahead.notFound': 'Not Found',
      'common.typeahead.nothingFound': 'Nothing Found',
      'common.typeahead.create': 'Create',
      'common.typeahead.noMatchingUser': 'No matching user',

      // avatar
      'avatar.upload': 'Upload',
      'avatar.change': 'Save',
      'avatar.zoom': 'Zoom',
      'avatar.rotation': 'Rotation',
      'avatar.rotate': 'Rotate',
      'avatar.save': 'Save Avatar',
      'avatar.open': 'Open file for avatar',

      // user profile
      'userProfile.header': 'User Profile',
      'userProfile.subHeader': 'Here you can see and edit your profile details',
      'userProfile.password.header': 'Change Password',
      'userProfile.password.subHeader':
        'You can change your account password here',
      'userProfile.firstName': 'First Name',
      'userProfile.lastName': 'Last Name',
      'userProfile.email': 'Email',
      'userProfile.phone': 'Phone',
      'userProfile.changePassword': 'Change Password',
      'userProfile.currentPassword': 'Current Password',
      'userProfile.newPassword': 'New Password',
      'userProfile.confirmPassword': 'Confirm Your New Password',
      'userProfile.changePassword.header': 'Change Password',
      'userProfile.changePassword.subHeader':
        'Please enter your new password and confirm it below',
      'userProfile.changePassword.passwordsDoNotMatch':
        'Passwords do not match',
      'userProfile.changePassword.error':
        'Error changing password. Please check your current password is correct',
      'userProfile.changePassword.success': 'Password changed successfully',

      // table
      'table.export': 'Export',
      'table.columnVisibility': 'Column visibility',
      'table.settings': 'Table Settings',
      'table.empty': 'There are no items to display',
      'table.loadMore': 'Load more',
      'table.delete': 'Delete',
      'table.json': 'JSON preview',
      'table.edit': 'Edit',
      'table.download': 'Download',
      'table.resend': 'Resend',
      'table.approve': 'Approve',
      'table.clearFilters': 'Clear filters',
      'table.addNew': 'Add new',
      'table.showFilters': 'Show filters',
      'table.hideFilters': 'Hide filters',
      'table.saveTableState': 'Save Table State',
      'table.clearTableFilterState': 'Clear Table Filter State',

      // filter operators - string
      'filter.clear': 'Clear Filter',
      'filter.string.contains': 'Contains',
      'filter.string.equals': 'Equals',
      'filter.string.notEquals': 'Not Equals',
      'filter.string.startsWith': 'Starts With',
      'filter.string.endsWith': 'Ends With',
      'filter.string.notContains': 'Not Contains',

      // filter operators - numeric
      'filter.numeric.equals': 'Equals',
      'filter.numeric.notEquals': 'Not Equals',
      'filter.numeric.greaterThan': 'Greater Than',
      'filter.numeric.greaterThanOrEqual': 'Greater Than or Equal',
      'filter.numeric.lessThan': 'Less Than',
      'filter.numeric.lessThanOrEqual': 'Less Than or Equal',
      'filter.numeric.between': 'Between',
      'filter.numeric.inRange': 'In Range',

      'filter.date.equals': 'Equals',
      'filter.date.notEquals': 'Not Equals',
      'filter.date.greaterThan': 'Greater Than',
      'filter.date.greaterThanOrEqual': 'Greater Than or Equal',
      'filter.date.lessThan': 'Less Than',
      'filter.date.lessThanOrEqual': 'Less Than or Equal',
      'filter.date.between': 'Between',
      'filter.date.inRange': 'In Range',

      // common errors
      'errors.fields.fieldLongerThen': 'Field is longer than',
      'errors.fields.characters': 'characters',
      'errors.fields.emptyFieldError': "Field can't be empty",

      // login form
      'login.header': 'Login into account',
      'login.subHeader': 'Enter your email and password to your account',
      'login.signIn': 'Sign in',
      'login.register': 'Register',
      'login.forgotPassword': 'Forgot password?',
      'login.continueWith': 'or continue with',
      'login.invalidCredentials': 'Invalid email or password',
      'login.terms':
        'By clicking continue, you agree to our Terms of Service and Privacy Policy.',

      // forgot password form
      'forgotPassword.header': 'Forgot Your Password?',
      'forgotPassword.subHeader':
        'Enter your email address to receive a password reset link',
      'forgotPassword.fields.email': 'Email',
      'forgotPassword.sendResetEmail': 'Send reset link',
      'forgotPassword.emailSent.header': 'Password Reset Submitted',
      'forgotPassword.emailSent.subHeader':
        'If we have an account matching your email address, you will receive an email to reset your password.',
      'forgotPassword.genericError': 'Error sending password reset link',

      // reset password form
      'resetPassword.header': 'Create New Password',
      'resetPassword.subHeader': 'Enter your new password',
      'resetPassword.completed.header': 'Password Reset Completed',
      'resetPassword.completed.subHeader':
        'You can now log in with your new password.',
      'resetPassword.confirm': 'Confirm',
      'resetPassword.invalidTokenOrEmail': 'Invalid token or email',

      'register.header': 'User Registration',
      'register.subHeader':
        'Enter your email and password to register your account',
      'register.fields.firstName': 'First Name',
      'register.fields.lastName': 'Last Name',
      'register.fields.email': 'Email',
      'register.fields.password': 'Password',
      'register.fields.confirmPassword': 'Confirm Password',
      'register.genericError': 'Error registering user',
      'register.error.passwordNotSame': 'The passwords should be the same',
      'register.success': 'User registered successfully',
      'register.terms':
        'By clicking register, you agree to our Terms of Service and Privacy Policy.',

      // print echeck
      'printECheck.header': 'Print your e-check',
      'printECheck.printing': 'Printing document',
      'printECheck.checkPrintedHeader': 'The check has been printed',
      'printECheck.checkPrintedInfo': 'You can now close this window',
      'printECheck.subHeader': `Please print your e-check on check paper or plain white paper. The number of times this e-check can be printed is limited and determined by the sender's settings.`,
      'printECheck.amount': 'Amount: ',
      'printECheck.dateIssued': 'Issued Date: ',
      'printECheck.onWhitePaper': 'Print on white paper',
      'printECheck.onCheckPaper': 'Print on check paper',
      'emptyECheckBlank.download': '  Download Blank',
      'emptyECheckBlank.whitePaper': 'White paper blank',
      'emptyECheckBlank.checkPaper': 'Check blank',
      'printECheck.allowPopupsMessage':
        'To print the check, please allow pop-ups from this site. You can do this by going to your browser settings and selecting',
      'printECheck.alwaysAllowPopups': "'Always allow pop-ups from this site'",
      'printECheck.error': 'Error printing echeck',
      'printECheck.printing.endTitle': 'How was you printing experience?',
      'printECheck.printing.endText':
        'if it was successful, please click confirm, if not cancel',
      'printECheck.aboutInfo':
        "Our checks work just like regular checks. The Bank Account must be verified for the sender to use this feature. However, we are not a bank and do not hold the check's funds. If you have printed the check on white paper, you may notice that the check is printed upside down.",
      'printECheck.printing.error':
        'Error printing echeck. Please try again or contact support.',

      // Common Scams
      'commonScams.header': 'Common Scams',
      'commonScams.subHeader':
        'Each scam involving a fraudulent check may be different, but some of the more common scenarios are:',
      'commonScams.sellingGoods.title': 'Selling Goods',
      'commonScams.sellingGoods.description':
        'You sell products in the marketplace, for example, over the Internet. A buyer sends you a check for the price you agreed on, and you ship the goods to the buyer. The check turns out to be fraudulent.',

      'commonScams.excessPurchase.title': 'Excess of the Purchase Price',
      'commonScams.excessPurchase.description':
        'This scenario is similar to the one described above. However, the buyer sends you a check for more than the purchase price and asks you to wire some or all of the excess to a third party, often in a foreign country. The check turns out to be fraudulent.',

      'commonScams.unexpectedWindfall.title': 'Unexpected Windfall”',
      'commonScams.unexpectedWindfall.description':
        "You receive a letter or email stating that you have won a foreign lottery or are the beneficiary of someone's estate. The letter/email will say you have to pay a processing or transfer tax/fee before receiving the money, but a check will be enclosed to cover that fee. You are asked to deposit the check and wire the fee to a third party, often in a foreign country. The check turns out to be fraudulent.",

      'commonScams.mysteryShopping.title': 'Mystery Shopping',
      'commonScams.mysteryShopping.description':
        'You receive a letter or email informing you that you have been chosen to act as a mystery shopper, along with a check to deposit. You are told to use a portion of the funds to purchase merchandise, transfer a part of the funds to a third party, and keep the remainder. The check turns out to be fraudulent.',

      // tenant list
      'tenantList.header': 'Tenant List',
      'tenantList.subHeader':
        "Here's a list of all active tenants in your account",
      'tenantList.shareSuccess': 'Tenant link copied to clipboard',
      'tenantList.menuItem.edit': 'Edit',
      'tenantList.menuItem.remove': 'Remove',
      'tenantList.deleteConfirm':
        'Are you sure you want to delete this tenant?',
      'tenantList.userRole.user': 'Tenant member',
      'tenantList.userRole.admin': 'Tenant administrator',
      'tenantList.userRole.notInTheTenant':
        'Not in this tenant',
      'tenantList.sandboxLabel': 'Sandbox',

      // tenant form
      'tenantForm.create.header': 'Tenant Form',
      'tenantForm.create.subHeader':
        'Fill in the details of the new tenant',
      'tenantForm.create.sucscefull': 'Tenant created successfully',
      'tenantForm.create.error': 'Error creating tenant',
      'tenantForm.edit.header': 'Edit tenant',
      'tenantForm.edit.subHeader': 'Edit tenant details',
      'tenantForm.edit.sucscefull': 'Tenant updated successfully',
      'tenantList.column.name': 'Name',
      'tenantList.column.description': 'Description',
      'tenantForm.edit.error': 'Error updating tenant',
      'tenantForm.sandbox.label': 'Sandbox Mode',
      'tenantForm.sandbox.placeholder':
        'Enable sandbox mode for testing purposes',

      // payments list
      'payments.header': 'Payments',
      'payments.filters.placeholder': 'filter by paid and status',
      'payments.filters.selected': 'Selected',
      'payments.filters.paidTo': 'Paid to',
      'payments.filters.status': 'Status',
      'payments.subHeader': "Here's a list of all active payments",

      // payee list
      'payeeList.header': 'Payee List',
      'payeeList.subHeader':
        "Here's a list of all active payees in the account",
      'payeeList.menuItem.edit': 'Edit',
      'payeeList.menuItem.remove': 'Remove',
      'payeeList.deleteConfirm': 'Are you sure you want to delete this payee?',
      'payeeList.column.id': 'Id',
      'payeeList.column.user': 'User',
      'payeeList.column.organization': 'Organization',
      'payeeList.column.nameOnCheck': 'Name On Check',
      'payeeList.column.email': 'Email',
      'payeeList.column.phone': 'Phone',
      'payeeList.column.address': 'Address',
      'payeeList.column.city': 'City',
      'payeeList.column.state': 'State',
      'payeeList.column.status': 'Status',
      'payeeList.column.zip': 'Zip',
      'payeeList.column.user.firstName': 'User First Name',
      'payeeList.column.user.lastName': 'User Last Name',
      'payeeList.column.user.email': 'User Email',
      'payeeList.column.payeeStatus.NotActive': 'Not active',
      'payeeList.column.payeeStatus.Deleted': 'Deleted',
      'payeeList.column.payeeStatus.Archive': 'Archive',
      'payeeList.column.payeeStatus.Active': 'Active',
      'payeeList.column.payeeStatus.Rejected': 'Rejected',
      'payeeList.column.payeeStatus.PendingForReview': 'Pending For Review',

      // payee form
      'payeeForm.create.header': 'Payee Form',
      'payeeForm.create.subHeader': 'Fill in the details of the new payee',
      'payeeForm.create.sucscefull': 'Payee created successfully',
      'payeeForm.create.error': 'Error creating payee',
      'payeeForm.edit.header': 'Edit payee',
      'payeeForm.edit.sucscefull': 'Payee updated successfully',
      'payeeForm.edit.subHeader': 'Edit payee details',
      'payeeForm.edit.error': 'Error updating payee',

      //bank list
      'bankList.header': 'Bank List',
      'bankList.subHeader': "Here's a list of all active banks in the account",
      'bankList.column.id': 'Id',
      'bankList.column.account': 'Account',
      'bankList.column.routing': 'Routing',
      'bankList.column.accountName': 'Account Name',
      'bankList.column.bankName': 'Bank Name',
      'bankList.column.companyName': 'Company Name',
      'bankList.column.address': 'Address',
      'bankList.column.city': 'City',
      'bankList.column.state': 'State',
      'bankList.column.zip': 'Zip',
      'bankList.column.createdOn': 'Created On',
      'bankList.deleteConfirm': 'Are you sure you want to delete this bank?',
      'bankList.actions.checkDesigner': 'Check designer',
      'bankList.actions.advancedCheckDesigner': 'Advanced designer',

      // bank form
      'bankForm.create.header': 'Bank Form',
      'bankForm.create.subHeader': 'Fill in the details of the new bank',
      'bankForm.create.sucscefull': 'Bank created successfully',
      'bankForm.create.error': 'Error creating bank',
      'bankForm.edit.header': 'Edit bank',
      'bankForm.edit.sucscefull': 'Bank updated successfully',
      'bankForm.edit.subHeader': 'Edit bank details',
      'bankForm.edit.error': 'Error updating bank',

      // payment list
      'paymentList.header': 'Payment List',
      'paymentList.subHeader':
        "Here's a list of all active payment in the account",
      'paymentList.deleteConfirm':
        'Are you sure you want to delete this payment?',
      'paymentList.column.id': 'Id',
      'paymentList.column.amount': 'Amount',
      'paymentList.column.bank': 'Bank Name',
      'paymentList.column.checkNumber': 'Check Number',
      'paymentList.column.checkDate': 'Check Date',
      'paymentList.column.deliveryTime': 'Delivery Time',
      'paymentList.column.note': 'Note',
      'paymentList.column.memo': 'Memo',
      'paymentList.column.name': 'Name',
      'paymentList.column.company': 'Company',
      'paymentList.column.nameOnCheck': 'Name On Check',
      'paymentList.column.verifyCode': 'Verify Code',
      'paymentList.column.referenceId': 'Reference Id',
      'paymentList.column.email': 'Email',
      'paymentList.column.phone': 'Phone',
      'paymentList.column.address': 'Address',
      'paymentList.column.city': 'City',
      'paymentList.column.state': 'State',
      'paymentList.column.zip': 'Zip',
      'paymentList.column.kId': 'KId',
      'paymentList.column.status': 'Status',
      'paymentList.column.payee': 'Payee',
      'paymentList.column.payee.label':
        'Type here to select existing payee, or create new one',
      'paymentList.column.payee.helpText':
        'Leave this field empty, if you would like to create a new payee',
      'paymentList.cardActions.print': 'Print check',
      'paymentList.cardActions.printDisabled':
        'You can not print this check, it is was either already printed or not approved',
      'paymentList.actions.resend': 'Payment has been resent',
      'paymentList.actions.approve': 'Payment has been approved',
      'paymentList.approveTitle':
        'Are you sure you want to approve this payment?',
      'paymentList.approveConfirm':
        "To approve this payment, please enter the check number and click the 'Approve' button below.",
      'paymentList.jsonPreviewTitle': 'Payment Request JSON Preview',
      'paymentList.jsonPreviewInfo':
        'This is the JSON representation of the payment request.',
      'paymentList.emailStatus': 'Email Status',
      'paymentList.emailStatusInfo': 'Payment Email Statuses',
      'paymentList.emailStatusInfoTitle':
        'Check email delivery statuses. Please note that only for 30 days after sending email statuses are stored.',

      // user payments
      'userPaymentList.header': 'My Payments',
      'userPaymentList.subHeader': "Here's a list of all your active payments",
      'userPayment.checkDetails': 'Check details',
      'userPayment.requestPayment': 'Request payment',

      // audit list
      'auditList.header': 'Audit History List',
      'auditList.subHeader': "Here's a list of all audit records in the app",
      'auditList.column.entityId': 'Entity id',
      'auditList.column.eventType': 'Event Type',
      'auditList.column.entityType': 'Entity Type',
      'auditList.column.description': 'Description',
      'auditList.column.createdAt': 'Created at',
      'auditList.column.createdBy': 'Created by',
      'auditList.column.id': 'Id',

      'auditList.payeeDescription':
        'Name: {{name}}, Email: {{email}}, Phone: {{phone}}, Status: {{status}}',

      'auditList.paymentDescription':
        'Amount: {{amount}}, Payee: {{payee}}, Status: {{status}}',

      'auditList.bankDescription':
        'Bank Name: {{bankName}}, Account Name: {{accountName}}, Routing: {{routing}}, Account: {{account}}, Company Name: {{companyName}}',

      'auditList.userDescription':
        'Name: {{firstName}} {{lastName}}, Email: {{email}}',

      'auditList.settingsDescription': 'Settings updated: {{name}}',
      'settings.Timezone': 'Timezone',
      'settings.NewECheckReceiveEmail': 'New ECheck Payment Email',
      'settings.ECheckPrintLimit': 'ECheck Print Limit',
      'settings.RedirectEmail': 'Redirect Email',
      'settings.AddedToOrganizationEmail': 'Added To Organization Email',

      'audit.status.PaymentCreated': 'Payment created',
      'audit.status.PaymentUpdated': 'Payment updated',
      'audit.status.PaymentDeleted': 'Payment deleted',
      'audit.status.PaymentVoided': 'Payment voided',
      'audit.status.PaymentSent': 'Payment sent',
      'audit.status.PaymentApproved': 'Payment approved',
      'audit.status.PaymentResented': 'Payment resent',

      'audit.status.PayeeCreated': 'Payee created',
      'audit.status.PayeeUpdated': 'Payee updated',
      'audit.status.PayeeDeleted': 'Payee deleted',

      'audit.status.BankCreated': 'Bank created',
      'audit.status.BankUpdated': 'Bank updated',
      'audit.status.BankDeleted': 'Bank deleted',

      'audit.status.UserCreated': 'User created',
      'audit.status.UserUpdated': 'User updated',
      'audit.status.UserDeleted': 'User deleted',
      'audit.status.UserAddedToOrganization': 'User added to organization',
      'audit.status.UserRemovedFromOrganization':
        'User removed from tenant',
      'audit.status.UserRegistered': 'User registered',
      'audit.status.UserUpdatedOwnProfile': 'User updated own profile',
      'audit.status.UserRightsUpdated': 'User rights updated',

      'audit.status.SettingsCreated': 'Settings created',
      'audit.status.SettingsUpdated': 'Settings updated',

      // payment request form
      'paymentRequestForm.create.header': 'Payment Request Form',
      'paymentRequestForm.create.subHeader':
        'Fill in the details of the new payment request',
      'paymentRequestForm.edit.sucscefull':
        'Payment request created successfully',
      'paymentRequestForm.edit.error': 'Error creating payment request',
      'paymentRequestForm.helpTex':
        'Select tenant first to create payment request',

      // bank form
      'paymentForm.create.header': 'Payment Form',
      'paymentForm.create.subHeader': 'Create of the new payment',
      'paymentForm.create.sucscefull': 'Payment created successfully',
      'paymentForm.create.error': 'Error creating payment',
      'paymentForm.edit.header': 'Edit payment',
      'paymentForm.edit.sucscefull': 'Payment updated successfully',
      'paymentForm.edit.subHeader': 'Edit payment details',
      'paymentForm.edit.error': 'Error updating payment',

      // user list
      'membersList.header': 'Members List',
      'membersList.subHeader':
        "Here's a list of all members users in the tenant",
      'membersList.deleteConfirm': 'Are you sure you want to delete this user?',
      'membersList.column.firstName': 'First Name',
      'membersList.column.lastName': 'Last Name',
      'membersList.column.email': 'Email',
      'membersList.column.userType': 'User Type',
      'membersList.column.userRights': 'User Rights',
      'membersList.column.phone': 'Phone',
      'membersList.removeFromOrganization': 'Remove',
      'membersList.userRights.ManageOrganization': 'Manage Organization',
      'membersList.userRights.ManageTenant': 'Manage Tenant',
      'membersList.userRights.MemberAdministration': 'Member Administration',
      'membersList.userRights.BankAccess': 'Bank Access',
      'membersList.userRights.PaymentProcessing': 'Payment Processing',
      'membersList.userRights.PayeeDirectory': 'Payee Directory',
      'membersList.userRights.ViewUserActivity': 'View User Activity',
      'membersList.userRights.SettingsAccess': 'Settings Access',
      'membersList.userRights.ApiDocumentationAccess':
        'API Documentation Access',
      'membersList.userRights.AuditLogsAccess': 'Audit Logs Access',
      'userForm.create.header': 'User Form',
      'userForm.create.subHeader': 'Fill in the details of the new user',
      'userForm.create.sucscefull': 'User created successfully',
      'userForm.create.error': 'Error creating user',
      'userForm.edit.header': 'Edit user',
      'userForm.edit.sucscefull': 'User updated successfully',
      'userForm.edit.subHeader': 'Edit user details',
      'userForm.edit.error': 'Error updating user',

      'userFor.invite.header': 'Invite User',
      'userFor.invite.subHeader':
        'Fill in the details of the new user to invite them to the tenant',
      'userForm.editRight.header': 'Edit user rights',
      'userForm.editRight.subHeader': 'Edit user rights in the tenant',
      'userForm.helpText':
        'By default, the admin user is granted all rights, while a simple user can only read their own checks and request them.',

      // General Settings
      'settings.tab': 'General',

      'settings.generalSettings.ECheckPrintLimit': 'ECheck Print Limit',
      'settings.generalSettings.ECheckPrintLimit.label':
        'The maximum number of times an e-check can be printed',
      'settings.generalSettings.RedirectEmail': 'Redirect Email',
      'settings.generalSettings.RedirectEmail.label':
        'Email address for redirecting notifications in sandbox mode',
      'settings.generalSettings.RedirectEmail.error':
        'Please enter a valid email address',

      // email designer
      'emailDesigner.tab': 'Email designer',
      'emailDesigner.tabs.edit': 'Edit',
      'emailDesigner.panel.text': 'Content',

      'emailDesigner.panel.spacer': 'Spacer block',
      'emailDesigner.panel.image.sourceUrl': 'Source URL',
      'emailDesigner.panel.image.altText': 'Alt Text',
      'emailDesigner.panel.image.clickUrl': 'Click through URL',
      'emailDesigner.panel.image.width': 'Width',
      'emailDesigner.panel.image.height': 'Height',
      'emailDesigner.panel.image.alignment': 'Alignment',
      'emailDesigner.panel.html': 'Content',
      'emailDesigner.panel.heading': 'Heading block',
      'emailDesigner.panel.heading.level': 'Level',
      'emailDesigner.panel.emailLayout': 'Global',
      'emailDesigner.panel.emailLayout.backdropColor': 'Backdrop color',
      'emailDesigner.panel.emailLayout.canvasColor': 'Canvas color',
      'emailDesigner.panel.emailLayout.canvasBorderColor':
        'Canvas border color',
      'emailDesigner.panel.emailLayout.canvasBorderRadius':
        'Canvas border radius',
      'emailDesigner.panel.emailLayout.fontFamily': 'Font family',
      'emailDesigner.panel.emailLayout.textColor': 'Text color',
      'emailDesigner.panel.dividerBlock': 'Divider block',
      'emailDesigner.panel.dividerBlock.color': 'Color',
      'emailDesigner.panel.dividerBlock.height': 'Height',
      'emailDesigner.panel.containerBlock': 'Container block',
      'emailDesigner.panel.columnsContainer': 'Number of columns',
      'emailDesigner.panel.columnsContainer.columnsGap': 'Columns gap',
      'emailDesigner.panel.columnsContainer.alignment': 'Alignment',
      'emailDesigner.panel.button': 'Button block',
      'emailDesigner.panel.button.text': 'Text',
      'emailDesigner.panel.button.url': 'Url',
      'emailDesigner.panel.button.width': 'Width',
      'emailDesigner.panel.button.width.full': 'Full',
      'emailDesigner.panel.button.width.auto': 'Auto',
      'emailDesigner.panel.button.size': 'Size',
      'emailDesigner.panel.button.style': 'Style',
      'emailDesigner.panel.button.style.rectangle': 'Rectangle',
      'emailDesigner.panel.button.style.rounded': 'Rounded',
      'emailDesigner.panel.button.style.pill': 'Pill',
      'emailDesigner.panel.button.style.textColor': 'Text color',
      'emailDesigner.panel.button.style.buttonColor': 'Button color',
      'emailDesigner.tabs.preview': 'Preview',
      'emailDesigner.actions.exportTemplate': 'Export template',
      'emailDesigner.actions.saveTemplate': 'Save template',
      'emailDesigner.actions.importTemplate': 'Import template',
      'emailDesigner.import.selectFileTitle': 'Import Email Template',
      'emailDesigner.import.selectFile': 'Import Email Template file (.json)',
      'emailDesigner.import.senseful': 'Document was imported successfully',
      'emailDesigner.import.fromOrganization': 'Or import from organization',
      'emailDesigner.import.buttonFromOrganization': 'Import from organization',
      'emailDesigner.save.senseful': 'Document was saved successfully',

      'emailDesigner.template.NewECheckReceiveEmail': 'ECheck Template',
      'emailDesigner.template.AddedToOrganizationEmail':
        'Added to tenant',
      'emailDesigner.actions.clearTemplate': 'Clear Template',
      'emailDesigner.actions.help': 'Design helper',
      'emailDesigner.error.invalidFile':
        'Cannot import this file, please check format',
      'emailDesigner.help.header': 'Design Helper',
      'emailDesigner.help.subHeader':
        'Here you can get information about email template keywords',

      // check designer keywords help
      'checkDesigner.help.keywords.title': 'Keywords',
      'checkDesigner.help.keywords.description': 'Description',
      'checkDesigner.help.description':
        'You can use the following keywords in the template to display the actual data',
      'checkDesigner.help.keywords.name_on_check':
        'The name of the user who receives the check',
      'checkDesigner.help.keywords.organization':
        'The name of the tenant that sends the check',
      'checkDesigner.help.keywords.organization_invite':
        'The name of the tenant that invites the user',
      'checkDesigner.help.keywords.amount': 'The amount of the transaction',
      'checkDesigner.help.keywords.link': 'The link to the print check page',
      'checkDesigner.help.keywords.link_invite':
        'The link website to join the tenant',
      'checkDesigner.help.keywords.verify': 'The link to the verify check page',
      'checkDesigner.help.keywords.name':
        ' The name of the user who was added to the tenant',

      'simpleCheckDesigners.advancedDesigner': 'Advanced designer',
      'simpleCheckDesigner.header': 'Simple Check Designer',
      'simpleCheckDesigner.subHeader':
        'Here you can design your check template',
      'simpleCheckDesigner.success': 'Template was successfully saved',

      // check designer
      'checkDesigner.actions.downloadTemplate': 'Download',
      'checkDesigner.actions.loadTemplate': 'Load Template',
      'checkDesigner.actions.changePDF': 'Change PDF',
      'checkDesigner.actions.previewPDF': 'Preview PDF',
      'checkDesigner.actions.saveComplete': 'Template was successfully saved',
      'checkDesigner.actions.saveTemplate': 'Save Template',
      'checkDesigner.actions.addField': 'Add Field',

      // signature pad
      'signaturePad.size': 'Size',
      'signaturePad.smoothing': 'Smoothing',
      'signaturePad.thinning': 'Thinning',
      'signaturePad.streamline': 'Streamline',
      'signaturePad.resetSettings': 'Reset settings',
      'signaturePad.clear': 'Clear',
      'signaturePad.save': 'Save',
      'signaturePad.open': 'Open file for signature',

      //check verification
      'verifyCheck.header': 'Check Verification',
      'verifyCheck.result': 'Verification Result',
      'verifyCheck.subHeader':
        'To verify the check, please enter the  verification code',
      'verifyCheck.code': 'verification code',
      'verifyCheck.verify': 'Verify Check',

      'verifyCheck.checkValid': 'Check is not valid',
      'verifyCheck.checkValidText':
        'The check you are looking with this <strong>{{code}}</strong> code, is not valid',
      'verifyCheck.returnBack': 'Return back to search',

      // legal sections
      'legal.disclaimer.header': 'Disclaimer',
      'legal.disclaimer.subHeader': 'Last Updated July 4, 2025',
      'legal.privacyPolicy.header': 'Privacy Policy',
      'legal.privacyPolicy.subHeader': 'Last Updated July 4, 2025',
      'legal.termsCondition.header': 'Terms of Use',
      'legal.termsCondition.subHeader': 'Last Updated July 4, 2025',

      // auth
      'auth.redirecting': 'Redirecting to login page...',
      'auth.completingSignIn': 'Completing sign-in...',
      'auth.failedSignIn': 'Failed to authenticate. Please try again.',
      'auth.noAuthTokenReceived': 'No authentication token received',
      'auth.failedToAuthenticate': 'Failed to authenticate user',
    },
  },
  uk: {
    translation: {},
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    resources,
    debug: process.env.I18N_DEBUG === 'true',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
